import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const Inventory = () => {
  const [token, setToken] = useState('');
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Product Name',
      dataIndex: 'productName'
    },
    {
      title: 'Product Width',
      dataIndex: 'width'
    },
    {
      title: 'Product Height',
      dataIndex: 'height'
    },
    {
      title: 'Product Length',
      dataIndex: 'length'
    },
    {
      title: 'Dimension Unit (cm/in)',
      dataIndex: 'demensionUnit'
    },
    {
      title: 'Product Weight',
      dataIndex: 'weight'
    },
    {
      title: 'Weight Unit (g/Kgs)',
      dataIndex: 'weightUnit'
    },
    {
      title: 'Estimated Quantity',
      dataIndex: 'estimateQuantity'
    },
    {
      title: 'Average Monthly Sales',
      dataIndex: 'averageMonthSale'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: 'EAN/UPC Barcode',
      dataIndex: 'eanUpc'
    },
    {
      title: 'Amazon Standard Identification Number',
      dataIndex: 'asin'
    },
    {
      title: 'Packing Method',
      dataIndex: 'packedMethod'
    },
    {
      title: 'Storage Method',
      dataIndex: 'storageMethod'
    },
    {
      title: 'Dangerous Goods Flag',
      dataIndex: 'dangerousGoods',
      render: (value: boolean) => (value ? 'O' : 'X')
    },
    {
      title: 'Lot Product Status',
      dataIndex: 'lotProduct'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1//warehouse/inventories?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    console.log(res.data);
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={data}
        />
      </div>
    </div>
  );
};

export default Inventory;
